import { useEffect, useState } from "react";
import { formatDistanceToNowStrict, formatDistanceStrict } from "date-fns";

import { getLocale } from "../../../../config/i18n";

function useTicker({ status, states } = {}) {
  const [distance, setDistance] = useState();

  useEffect(() => {
    let ticker;

    const update = () => {
      if (!Array.isArray(states)) return;
      if (!status) return;
      let distance;

      try {
        const createdAt = new Date(
          states
            .filter((s) => s.status === status)
            .sort((a, b) => b.createdAt - a.createdAt)[0].createdAt
        );
        if (status === "fulfilled") {
          const activeAt = new Date(
            states
              .filter((s) => s.status === "active")
              .sort((a, b) => b.createdAt - a.createdAt)[0].createdAt
          );
          distance = formatDistanceStrict(activeAt, createdAt, {
            locale: getLocale(),
            addSuffix: false,
          });
        } else {
          distance = formatDistanceToNowStrict(createdAt, {
            locale: getLocale(),
            addSuffix: true,
          });
        }

        setDistance(distance);
      } catch {}

      // Bug real (auditoría 2026-08-14): el timer se re-armaba en el
      // efecto de arriba, disparado sólo por un re-render — pero
      // setDistance con el MISMO string que ya tenía (ej. "hace 5
      // minutos" durante toda esa ventana de 60s) hace bail-out de React
      // (no re-renderiza), así que el efecto nunca volvía a correr y el
      // timer de un solo disparo quedaba muerto para siempre. Re-armarse
      // acá adentro no depende de que React decida re-renderizar.
      ticker = setTimeout(update, 1000);
    };
    update();
    return () => clearTimeout(ticker);
  });

  return distance;
}

export default useTicker;
